export enum CounterDictionary
{
	D = 'booking_delayed',
	AC = 'booking_unconfirmed',
}

export enum ConfirmedFilterValue
{
	Y = 1,
	N = 0,
}
